import React from 'react';

const SwitchUserRoute =()=>{
    return <div>Switch User</div>
}
export default SwitchUserRoute;